<template>
    <div>
    <h1 style="font-size: 24px; color: black;">各项服务器公摊费用表</h1>
    <el-card class="form-container" shadow="never">
        <el-form :inline="true" :model="queryData" size="small" label-width="140px">
            <el-form-item label="应用：">
                <el-select v-model="queryData.appId" placeholder="请选择"  >
                    <el-option :key="-1" label="全部" :value = "-1"></el-option>
                    <el-option v-for="app in appList"
                               :key="app.appId"
                               :label="app.appName"
                               :value="app.appId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="月份：">
                <el-date-picker
                        unlink-panels
                        v-model="queryData.timeDate"
                        type="monthrange"
                        range-separator="至"
                        start-placeholder="开始月份"
                        end-placeholder="结束月份">
                </el-date-picker>
            </el-form-item>
            <el-form-item label=" " class="sub-sub10" >
                <el-button type="primary" @click="search">查询</el-button>
                <el-button type="primary" @click="showDetails('添加成本')">添加</el-button>
            </el-form-item>
        </el-form>
    </el-card>
        <div style="margin-top: 20px">
            <el-table border max-height="550"
                      :data="list">
                <el-table-column  label="编号" prop="id"  align="center"></el-table-column>
                <el-table-column  label="费用产生月份"  align="center">
                    <template slot-scope="scope">
                        {{formatDate(scope.row.costDt,"yyyy-MM")}}
                    </template>
                </el-table-column>
                <el-table-column  label="产品"  align="center">
                    <template slot-scope="scope">
                        {{scope.row.appId | commonFilter(appObj)}}
                    </template>
                </el-table-column>
                <el-table-column label="费用描述" prop="description" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  label="总费用"  prop="cost" align="center" ></el-table-column>
                <el-table-column  label="费用凭证" width="120px" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.proof !== null && scope.row.proof !== ''">
                            <el-popover trigger="hover" placement="left">
                                <img :src="VUE_APP_CDN_URL+scope.row.proof" width="925px" height="425px" alt="banner图片">
                                <img :src="VUE_APP_CDN_URL+scope.row.proof" slot="reference" width="50px" height="50px" alt="图片">
                            </el-popover>
                        </div>
<!--                        <template>-->
<!--                            <img :src="VUE_APP_CDN_URL+scope.row.proof" width="60px" height="60px" />-->
<!--                        </template>-->
                    </template>
                </el-table-column>
                <el-table-column  label="操作"  align="center">
                    <template slot-scope="scope">
                        <el-button  plain size="mini" type="primary" @click="showDetails('编辑成本',scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
                <el-form :model="editForm" :label-width="labelWidth">
                    <el-form-item label="应用：">
                        <el-select v-model="editForm.appId" placeholder="请选择"  >
                            <el-option v-for="app in appList"
                                       :key="app.appId"
                                       :label="app.appName"
                                       :value="app.appId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="描述 :" :label-width="labelWidth">
                        <el-input  type="text" v-model="editForm.description"  ></el-input>
                    </el-form-item>
                    <el-form-item label="费用 :" :label-width="labelWidth">
                        <el-input-number :precision="2" :min="0" :step="0.1"  v-model="editForm.cost"  ></el-input-number>
                    </el-form-item>
                    <el-form-item label="费用产生月份 :" :label-width="labelWidth" >
                        <el-date-picker
                        v-model="editForm.costDt"
                        type="month"
                        placeholder="选择月">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="费用凭证:" :label-width="labelWidth">
                        <el-upload
                                :headers="headers"
                                class="avatar-uploader"
                                :action="uploadURL"
                                :show-file-list="false"
                                :on-success="handleImageSuccess"
                                :before-upload="function (file) { return beforeAvatarUpload(file)}"
                                @click="uploadImage">
                            <img v-if="editForm.proof" :src="VUE_APP_CDN_URL+editForm.proof" class="avatar">
                            <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmForm">确 定</el-button>
                        <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </div>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
        </el-pagination>

    </div>
</template>

<script>
    import settingMix from '@/utils/mix/common-setting'
    import {
        upload,
        saveAppSharedExpenses,
        searchAppSharedExpenses
    } from "@/http/financialApi";
    import utils from '@/utils';
    import DateUtil from '@/utils/DateUtil'
    export default {
        name: "AppSharedExpenses",
        mixins: [settingMix],
        data(){
            return{
                VUE_APP_FINANCIAL_URL:'',
                VUE_APP_CDN_URL:'',
                needGetApp: true,
                headers:{},
                list:[],
                labelWidth: '150px',
                uploadURL: process.env.VUE_APP_FINANCIAL_URL + "sharedExpenses/upload",
                dialogVisible: false,
                dialogTitle :'',
                editForm: {},
                queryData: {
                    timeDate:['',''],
                    appId: -1
                },
                appList:[],
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
            }
        },
        methods:{
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            search() {
                this.queryData.size = this.page.size;
                this.queryData.page = this.page.page;
                this.queryData.startDt = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endDt = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                searchAppSharedExpenses(this.queryData).then(resp => {
                    this.list = resp.data.info.content;
                    this.page.totalElements = resp.data.info.total
                })
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            handleImageSuccess(response){
                this.editForm.proof=response.info;
            },

            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },
            uploadImage(){
                let func = upload;
                func().then().catch(function () {
                })
            },
            showDetails(title, row) {
                this.editForm = {
                    "id" : 0,
                    "costDt": '',
                    "appId":1,
                    "description" :'',
                    "cost" : 1.00,
                    "proof" : ''

                };

                this.dialogTitle = title;
                this.dialogVisible = true;

                if(row){
                    this.editForm = {
                        "id" : row.id,
                        "costDt": row.costDt,
                        "appId":row.appId,
                        "description" :row.description,
                        "cost" : row.cost,
                        "proof" : row.proof,
                    };
                }
            },
            confirmForm(){
                let _message = '';
                if(this.editForm.appId===''){
                    _message = '请选择应用'
                }else if (this.editForm.cost==='' || this.editForm.cost === null){
                    _message = '请输入费用'
                }else if (this.editForm.proof===''){
                    _message = '请上传凭证'
                }else if (this.editForm.costDt ==='' || this.editForm.costDt ===null){
                    _message = '请选择月份'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                this.editForm.costDt = utils.DateUtil.formatDate(this.editForm.costDt, "yyyy-MM-DD");

                saveAppSharedExpenses(this.editForm).then(resp => {
                    if (resp.data.status === 0 ){
                        this.search();
                        this.dialogVisible = false;
                    }
                });
            },
            initDateRange() {
                this.queryData.timeDate = DateUtil.getIntervalMonthWithNoFormat(1)
            }
        },
        created() {
            this.headers ={Authorization : this.$store.state.user.token};
            this.search();
            this.initDateRange();
        },
        mounted() {
            this.VUE_APP_FINANCIAL_URL=process.env.VUE_APP_FINANCIAL_URL;
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }

    }
</script>

<style scoped>

</style>